import { Text } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledText = styled(Text)`
  &&& {
    line-height: var(--cl-line-height-4);
  }
`;
